module.exports = __webpack_public_path__ + "static/img/tabela.6ba7d1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_guarana/tabela.png
// module id = jC1L
// module chunks = 0